import { useQueryClient } from '@tanstack/react-query'

import { useIndividualsServicePatchV1IndividualsByIndividualIdRelation } from '../client/queries'
import { INDIVIDUAL_INVALIDATION_KEYS } from './regen-invalidation'

export const useUpdateRelation = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePatchV1IndividualsByIndividualIdRelation({
    onSuccess: () => {
      for (const key of INDIVIDUAL_INVALIDATION_KEYS) {
        queryClient.invalidateQueries({ queryKey: [key] })
      }
    },
  })
}
